import { IIsiDtoComponentV4 } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoComponentV4 } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoComponentClientState } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoComponentClientState } from "./Isilog.IsiFramework.IsiDataTransferObject";

export interface IIsiDtoGrid extends IIsiDtoComponentV4  {
    /** Dans le cadre d'une grille hierarchique, définit le nom de la colonne qui stocke le booléen qui indique si la ligne en cours a un enfant ou non */
    hasChildColumnName?: string;
    isSingleColumnTemplate?: boolean;
    /** Indique que la grille doit activer le mouseDown */
    withMouseDown?: boolean;
    /** Indique si la colonne de fin doit prendre toute la place restante
Par défaut true */
    expandLastColumn?: boolean;
    /** Mode de calcul de la hauteur d'une ligne d'une grille */
    rowHeightMode?: string;
    /** Hauteur (en px) d'une ligne d'une grille ou hauteur max (depend du RowHeightMode) */
    rowHeight?: number;
    /** Indique si l'on souhaite déplier par défaut les niveaux d'une grille hierarchique */
    expandAll?: number;
    /** Mode d'enregistrement de la grille */
    gridSaveMode?: SaveMode;
    /** Gets or sets the data source. */
    dataSource?: IIsiDtoGridDataSource;
    /** Obtient ou définit si la hauteur de la grille doit être automatique */
    autoHeight?: boolean;
    height?: string;
    /** Obtient ou définie la clé primaire réelle. La grille ne permet pas de travailler directement avec des clés composites. Techniquement la clé primaire
de la grille doit donc être une colonne unique. Cependant, il peut arriver que les enregistrements est une clé composées et nous auront besoin de cette information */
    realPk?: string[];
    /** Obtient ou définit la clé primaire. */
    pk?: string;
    /** Obtient ou définie l'url complète pour les modifications.
Par défaut : ~/?sessionID=IsiContext.SessionId    (en sachant que le tild sera remplacé par BaseUrl) */
    updatedUrl?: string;
    nbMaxColumns?: number;
    nbMaxRecords?: number;
    /** Obtient la liste des fonctionnalités actives sur la grille. */
    features?: IIsiDtoGridFeatures;
    /** Mode d'affichage de la grille hiérarchique */
    mode?: Mode;
    /** L'inseption car on peut avoir d'autre columnslayout niveau n+1 */
    columnsLayout?: IIsiDtoGridColumnLayout;
    columns?: IIsiDtoGridColumn[];
    /** La datasource permettant de récupérer les informations de text associés à la colonnes / éditeur type isicombo
 => formatter
 => IsiComboEditorProvider */
    columnsDataSources?: { [key: string]: IIsiDtoGridColumnDataSource; };
}
/** Mode de sauvegarde */
export enum SaveMode {
    None = 0,
    Explicite = 1,
    Implicite = 2,
}
export interface IIsiDtoGridDataSource extends IIsiDataTransferObject  {
    /** Obtient ou définit si l'url de la source de donnée. */
    loadUrl?: string;
    /** Obtient ou définit si l'url de la source de donnée. */
    baseUrl?: string;
    /** Obtient ou définit le type de la source de donnée */
    dataSourceType?: DataSourceTypeValue;
    /** Obtient ou définit le nom de l'identifiant unique du champ. */
    primaryKey?: string;
    /** Obtient ou définit l''emplacement de la propriété qui contient le tableau d'enregistrements. */
    responseDataKey?: string;
    /** Obtient ou définit le type de contenu de la réponse. */
    responseContentType?: string;
    /** Obtient ou définit le type des données retournées par la source. */
    responseDataType?: string;
}
/** Interface décrivant un objet regroupant l'ensemble des features de la grille */
export interface IIsiDtoGridFeatures extends IIsiDataTransferObject  {
    /** Obtient ou définit la configuration de la fonction propriété (consultation de l'enregistrement). */
    property?: IIsiDtoGridPropertyFeature;
    /** Obtient ou définit la configuration de la fonction d'ajout de selecteur de ligne dans les lignes */
    rowSelectors?: IIsiDtoGridRowSelectorsFeature;
    /** Obtient ou définit la feature des tooltips. */
    tooltips?: IIsiDtoGridTooltipsFeature;
    /** Obtient ou définit la configuration de la fonction de déplacement (réordonnancement) des colonnes */
    columnMoving?: IIsiDtoGridColumnMovingFeature;
    /** Obtient ou définit la configuration de la fonction de redimensionnement des colonnes. */
    resizing?: IIsiDtoGridResizingFeature;
    /** Obtient ou définit la configuration de chargement des lignes à la demande. */
    appendRowsOnDemand?: IIsiDtoGridAppendRowsOnDemandFeature;
    /** Obtient ou définit la configuration de la fonction de selection des lignes. */
    selection?: IIsiDtoGridSelectionFeature;
    /** Obtient ou définit la configuration de la fonction de filtrage. */
    filtering?: IIsiDtoGridFilteringFeature;
    /** Obtient ou définit la configuration de la fonction de redimensionnement de la grille (responsive). */
    hiding?: IIsiDtoGridHidingFeature;
    responsive?: IIsiDtoGridResponsiveFeature;
    /** Obtient ou définit la configuration de la fonction de mise à jour (édition) des cellules. */
    updating?: IIsiDtoGridUpdatingFeature;
    /** Obtient ou définit la configuration de la fonction de tri. */
    sorting?: IIsiDtoGridSortingFeature;
    /** Obtient ou définit la configuration de la fonction de pagination. */
    paging?: IIsiDtoGridPagingFeature;
    /** Obtient ou définit la configuration de la fonction de groupement. */
    grouping?: IIsiDtoGridGroupingFeature;
}
/** Interface décrivant un objet feature (fonctionnalité) de ma grille */
export interface IIsiDtoGridFeature extends IIsiDataTransferObject  {
    /** Obtient le mode de fonctionnement de la feature sous la forme souhaitée pour la sérialisation via DataContract. */
    type?: string;
}
/** Fonction propriété (consultation de l'enregistrement) */
export interface IIsiDtoGridPropertyFeature extends IIsiDtoGridFeature  {
    /** Obtient ou définit pour chaque écran les droits d'accéder à l'écran */
    rights?: { [key: string]: boolean; };
    /** Obtient ou définit les colonnes permettant d'aller sur l'écran propriété (écran différent en fonction de la ligne) */
    columns?: string[];
    /** Obtient ou définit la colonne permettant d'identifier l'écran */
    screenColumn?: string;
    /** Obtient ou définit l'écran propriété de manière statique (identique pour toute les lignes). */
    screen?: string;
    /** Obtient ou définit que l'on utilise le traitement par défaut du composant IsiGrid. 
dans le cas ou cette option vaut 
true => un event composant server side et lancé
false => un event client est lancé à la charge du composant gérant la grille de prendre le relais sur la gestion de l'action. */
    useGridBehaviour?: boolean;
}
/** Objet de base représentant une feature (fonctionnalité) de ma grille */
export class IsiDtoGridFeature extends IsiDataTransferObject implements IIsiDtoGridFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridFeature, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient le mode de fonctionnement de la feature sous la forme souhaitée pour la sérialisation via DataContract. */
    type?: string;

    constructor(data?: IIsiDtoGridFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridFeature): IsiDtoGridFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}
/** Fonction propriété (consultation de l'enregistrement) */
export class IsiDtoGridPropertyFeature extends IsiDtoGridFeature implements IIsiDtoGridPropertyFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridPropertyFeature, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définit pour chaque écran les droits d'accéder à l'écran */
    rights?: { [key: string]: boolean; };
    /** Obtient ou définit les colonnes permettant d'aller sur l'écran propriété (écran différent en fonction de la ligne) */
    columns?: string[];
    /** Obtient ou définit la colonne permettant d'identifier l'écran */
    screenColumn?: string;
    /** Obtient ou définit l'écran propriété de manière statique (identique pour toute les lignes). */
    screen?: string;
    /** Obtient ou définit que l'on utilise le traitement par défaut du composant IsiGrid. 
dans le cas ou cette option vaut 
true => un event composant server side et lancé
false => un event client est lancé à la charge du composant gérant la grille de prendre le relais sur la gestion de l'action. */
    useGridBehaviour?: boolean;

    constructor(data?: IIsiDtoGridPropertyFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rights = _data["rights"] !== undefined ? _data["rights"] : <any>null;
            this.columns = _data["columns"];
            this.screenColumn = _data["screenColumn"] !== undefined ? _data["screenColumn"] : <any>null;
            this.screen = _data["screen"] !== undefined ? _data["screen"] : <any>null;
            this.useGridBehaviour = _data["useGridBehaviour"] !== undefined ? _data["useGridBehaviour"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGridPropertyFeature): IsiDtoGridPropertyFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridPropertyFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["rights"] = this.rights !== undefined ? this.rights : <any>null;
        data["columns"] = this.columns !== undefined ? this.columns : [];
        data["screenColumn"] = this.screenColumn !== undefined ? this.screenColumn : <any>null;
        data["screen"] = this.screen !== undefined ? this.screen : <any>null;
        data["useGridBehaviour"] = this.useGridBehaviour !== undefined ? this.useGridBehaviour : false;
        return data;
    }
}
/** Fonction permettant d'ajouter un selecteur (checkbox) dans les lignes pour les sélectionner */
export interface IIsiDtoGridRowSelectorsFeature extends IIsiDtoGridFeature  {
    /** Obtient ou définit la largeur de la colonne contenant les checkbox. */
    columnWidth?: string;
    enableCheckBoxes?: boolean;
}
/** Fonction permettant d'ajouter un selecteur (checkbox) dans les lignes pour les sélectionner */
export class IsiDtoGridRowSelectorsFeature extends IsiDtoGridFeature implements IIsiDtoGridRowSelectorsFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridRowSelectorsFeature, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définit la largeur de la colonne contenant les checkbox. */
    columnWidth?: string;
    enableCheckBoxes?: boolean;

    constructor(data?: IIsiDtoGridRowSelectorsFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.columnWidth = _data["columnWidth"] !== undefined ? _data["columnWidth"] : <any>null;
            this.enableCheckBoxes = _data["enableCheckBoxes"] !== undefined ? _data["enableCheckBoxes"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGridRowSelectorsFeature): IsiDtoGridRowSelectorsFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridRowSelectorsFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["columnWidth"] = this.columnWidth !== undefined ? this.columnWidth : <any>null;
        data["enableCheckBoxes"] = this.enableCheckBoxes !== undefined ? this.enableCheckBoxes : false;
        return data;
    }
}
export interface IIsiDtoGridTooltipsFeature extends IIsiDtoGridFeature  {
}
export class IsiDtoGridTooltipsFeature extends IsiDtoGridFeature implements IIsiDtoGridTooltipsFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridTooltipsFeature, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoGridTooltipsFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoGridTooltipsFeature): IsiDtoGridTooltipsFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridTooltipsFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
/** Fonction de déplacement (réordonnancement) des colonnes */
export interface IIsiDtoGridColumnMovingFeature extends IIsiDtoGridFeature  {
    /** Indique si l'on souhaite le controle permettant de déplacer la colonne a une certaine position */
    addMovingDropdown?: boolean;
}
/** Fonction de déplacement (réordonnancement) des colonnes */
export class IsiDtoGridColumnMovingFeature extends IsiDtoGridFeature implements IIsiDtoGridColumnMovingFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridColumnMovingFeature, Isilog.IsiFramework.IsiDataTransferObject";
    /** Indique si l'on souhaite le controle permettant de déplacer la colonne a une certaine position */
    addMovingDropdown?: boolean;

    constructor(data?: IIsiDtoGridColumnMovingFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.addMovingDropdown = _data["addMovingDropdown"] !== undefined ? _data["addMovingDropdown"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGridColumnMovingFeature): IsiDtoGridColumnMovingFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumnMovingFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["addMovingDropdown"] = this.addMovingDropdown !== undefined ? this.addMovingDropdown : false;
        return data;
    }
}
/** Fonction de redimensionnement des colonnes */
export interface IIsiDtoGridResizingFeature extends IIsiDtoGridFeature  {
}
/** Fonction de redimensionnement des colonnes */
export class IsiDtoGridResizingFeature extends IsiDtoGridFeature implements IIsiDtoGridResizingFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridResizingFeature, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoGridResizingFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoGridResizingFeature): IsiDtoGridResizingFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridResizingFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
/** Fonction de chargement des lignes à la demande */
export interface IIsiDtoGridAppendRowsOnDemandFeature extends IIsiDtoGridFeature  {
    checkAllPreload?: number;
    scrollContainer?: string;
    triggerAuto?: boolean;
    chunkSize?: number;
}
/** Fonction de chargement des lignes à la demande */
export class IsiDtoGridAppendRowsOnDemandFeature extends IsiDtoGridFeature implements IIsiDtoGridAppendRowsOnDemandFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridAppendRowsOnDemandFeature, Isilog.IsiFramework.IsiDataTransferObject";
    checkAllPreload?: number;
    scrollContainer?: string;
    triggerAuto?: boolean;
    chunkSize?: number;

    constructor(data?: IIsiDtoGridAppendRowsOnDemandFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.checkAllPreload = _data["checkAllPreload"] !== undefined ? _data["checkAllPreload"] : null;
            this.scrollContainer = _data["scrollContainer"] !== undefined ? _data["scrollContainer"] : <any>null;
            this.triggerAuto = _data["triggerAuto"] !== undefined ? _data["triggerAuto"] : false;
            this.chunkSize = _data["chunkSize"] !== undefined ? _data["chunkSize"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoGridAppendRowsOnDemandFeature): IsiDtoGridAppendRowsOnDemandFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridAppendRowsOnDemandFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["checkAllPreload"] = this.checkAllPreload !== undefined ? this.checkAllPreload : null;
        data["scrollContainer"] = this.scrollContainer !== undefined ? this.scrollContainer : <any>null;
        data["triggerAuto"] = this.triggerAuto !== undefined ? this.triggerAuto : false;
        data["chunkSize"] = this.chunkSize !== undefined ? this.chunkSize : 0;
        return data;
    }
}
/** Fonction de selection de lignes */
export interface IIsiDtoGridSelectionFeature extends IIsiDtoGridFeature  {
    multi?: boolean;
}
/** Fonction de selection de lignes */
export class IsiDtoGridSelectionFeature extends IsiDtoGridFeature implements IIsiDtoGridSelectionFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridSelectionFeature, Isilog.IsiFramework.IsiDataTransferObject";
    multi?: boolean;

    constructor(data?: IIsiDtoGridSelectionFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.multi = _data["multi"] !== undefined ? _data["multi"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGridSelectionFeature): IsiDtoGridSelectionFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSelectionFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["multi"] = this.multi !== undefined ? this.multi : false;
        return data;
    }
}
/** Fonction de filtrage */
export interface IIsiDtoGridFilteringFeature extends IIsiDtoGridFeature  {
    globalFilterValue?: string;
    /** Obtient ou définit si les filtres appliqués à la grille doivent etre formates (avec un tolower
ou un toupper par exemple).
Si la valeur est true, aucune fonction ne sera appliquée */
    cSen?: boolean;
    /** Obtient ou définit le titel à appliquer sur le champ */
    gfTitle?: string;
    /** Obtient ou définit une classe css à appliquer sur le champ de recherche. */
    gfCSSClass?: string;
    /** Obtient ou définit le libellé afficher en surimpression dans le champ de recherche (placeholder). */
    gfPH?: string;
    /** Obtient ou définit le sélecteur permettant de récupérer le conteneur dans lequel champ de recherche va être ajouté */
    gfC?: string;
    /** Obtient ou définit si lorsque la recherche globale est lancée, si il faut supprimer les autres filtres */
    gfClearAll?: boolean;
    /** Active ou non la recherche globale. */
    gf?: boolean;
}
/** Fonction de filtrage */
export class IsiDtoGridFilteringFeature extends IsiDtoGridFeature implements IIsiDtoGridFilteringFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridFilteringFeature, Isilog.IsiFramework.IsiDataTransferObject";
    globalFilterValue?: string;
    /** Obtient ou définit si les filtres appliqués à la grille doivent etre formates (avec un tolower
ou un toupper par exemple).
Si la valeur est true, aucune fonction ne sera appliquée */
    cSen?: boolean;
    /** Obtient ou définit le titel à appliquer sur le champ */
    gfTitle?: string;
    /** Obtient ou définit une classe css à appliquer sur le champ de recherche. */
    gfCSSClass?: string;
    /** Obtient ou définit le libellé afficher en surimpression dans le champ de recherche (placeholder). */
    gfPH?: string;
    /** Obtient ou définit le sélecteur permettant de récupérer le conteneur dans lequel champ de recherche va être ajouté */
    gfC?: string;
    /** Obtient ou définit si lorsque la recherche globale est lancée, si il faut supprimer les autres filtres */
    gfClearAll?: boolean;
    /** Active ou non la recherche globale. */
    gf?: boolean;

    constructor(data?: IIsiDtoGridFilteringFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.globalFilterValue = _data["globalFilterValue"] !== undefined ? _data["globalFilterValue"] : <any>null;
            this.cSen = _data["cSen"] !== undefined ? _data["cSen"] : false;
            this.gfTitle = _data["gfTitle"] !== undefined ? _data["gfTitle"] : <any>null;
            this.gfCSSClass = _data["gfCSSClass"] !== undefined ? _data["gfCSSClass"] : <any>null;
            this.gfPH = _data["gfPH"] !== undefined ? _data["gfPH"] : <any>null;
            this.gfC = _data["gfC"] !== undefined ? _data["gfC"] : <any>null;
            this.gfClearAll = _data["gfClearAll"] !== undefined ? _data["gfClearAll"] : false;
            this.gf = _data["gf"] !== undefined ? _data["gf"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGridFilteringFeature): IsiDtoGridFilteringFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridFilteringFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["globalFilterValue"] = this.globalFilterValue !== undefined ? this.globalFilterValue : <any>null;
        data["cSen"] = this.cSen !== undefined ? this.cSen : false;
        data["gfTitle"] = this.gfTitle !== undefined ? this.gfTitle : <any>null;
        data["gfCSSClass"] = this.gfCSSClass !== undefined ? this.gfCSSClass : <any>null;
        data["gfPH"] = this.gfPH !== undefined ? this.gfPH : <any>null;
        data["gfC"] = this.gfC !== undefined ? this.gfC : <any>null;
        data["gfClearAll"] = this.gfClearAll !== undefined ? this.gfClearAll : false;
        data["gf"] = this.gf !== undefined ? this.gf : false;
        return data;
    }
}
/** Fonction de tri */
export interface IIsiDtoGridHidingFeature extends IIsiDtoGridFeature  {
    columnSettings?: IIsiDtoGridHidingFeatureColumnSettings[];
}
export interface IIsiDtoGridColumnSettings extends IIsiDataTransferObject  {
}
/** Fonction de mise à jour des cellules */
export interface IIsiDtoGridHidingFeatureColumnSettings extends IIsiDtoGridColumnSettings  {
    /** Détermine si la colonne doit être masqué. */
    hidden?: boolean;
    /** Détermine si la colonne peut être masquée. */
    allowHiding?: boolean;
    /** Détermine le code de la colonne. */
    columnKey?: string;
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridColumnSettings extends IsiDataTransferObject implements IIsiDtoGridColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoGridColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoGridColumnSettings): IsiDtoGridColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
/** Fonction de masquage des cellules */
export class IsiDtoGridHidingFeatureColumnSettings extends IsiDtoGridColumnSettings implements IIsiDtoGridHidingFeatureColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridHidingFeatureColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";
    /** Détermine si la colonne doit être masqué. */
    hidden?: boolean;
    /** Détermine si la colonne peut être masquée. */
    allowHiding?: boolean;
    /** Détermine le code de la colonne. */
    columnKey?: string;

    constructor(data?: IIsiDtoGridHidingFeatureColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hidden = _data["hidden"] !== undefined ? _data["hidden"] : false;
            this.allowHiding = _data["allowHiding"] !== undefined ? _data["allowHiding"] : false;
            this.columnKey = _data["columnKey"] !== undefined ? _data["columnKey"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridHidingFeatureColumnSettings): IsiDtoGridHidingFeatureColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridHidingFeatureColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["hidden"] = this.hidden !== undefined ? this.hidden : false;
        data["allowHiding"] = this.allowHiding !== undefined ? this.allowHiding : false;
        data["columnKey"] = this.columnKey !== undefined ? this.columnKey : <any>null;
        return data;
    }
}
/** Fonction de filtrage */
export class IsiDtoGridHidingFeature extends IsiDtoGridFeature implements IIsiDtoGridHidingFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridHidingFeature, Isilog.IsiFramework.IsiDataTransferObject";
    columnSettings?: IsiDtoGridHidingFeatureColumnSettings[];

    constructor(data?: IIsiDtoGridHidingFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.columnSettings = _data["columnSettings"] !== undefined ? _data["columnSettings"] : [];
        }
    }

    static fromJS(data?: IIsiDtoGridHidingFeature): IsiDtoGridHidingFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridHidingFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["columnSettings"] = this.columnSettings !== undefined ? this.columnSettings : [];
        return data;
    }
}
/** Fonction de redimensionnement de la grille (responsive) */
export interface IIsiDtoGridResponsiveFeature extends IIsiDtoGridFeature  {
    nbMaxColumn?: number;
    isSingleColumnEnabled?: boolean;
    responsiveModes?: { [key: string]: IIsiDtoGridResponsiveMode; };
}
/** Interface gérant les dimensions minimales et maximales des modes responsives */
export interface IIsiDtoGridResponsiveMode extends IIsiDtoGridFeature  {
    singleColumnTemplate?: string;
    maxWidth?: number;
    minWidth?: number;
}
/** Classe gérant les dimensions minimales et maximales des modes responsives */
export class IsiDtoGridResponsiveMode extends IsiDtoGridFeature implements IIsiDtoGridResponsiveMode {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridResponsiveMode, Isilog.IsiFramework.IsiDataTransferObject";
    singleColumnTemplate?: string;
    maxWidth?: number;
    minWidth?: number;

    constructor(data?: IIsiDtoGridResponsiveMode) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.singleColumnTemplate = _data["singleColumnTemplate"] !== undefined ? _data["singleColumnTemplate"] : <any>null;
            this.maxWidth = _data["maxWidth"] !== undefined ? _data["maxWidth"] : 0;
            this.minWidth = _data["minWidth"] !== undefined ? _data["minWidth"] : 0;
        }
    }

    static fromJS(data?: IIsiDtoGridResponsiveMode): IsiDtoGridResponsiveMode {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridResponsiveMode();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["singleColumnTemplate"] = this.singleColumnTemplate !== undefined ? this.singleColumnTemplate : <any>null;
        data["maxWidth"] = this.maxWidth !== undefined ? this.maxWidth : 0;
        data["minWidth"] = this.minWidth !== undefined ? this.minWidth : 0;
        return data;
    }
}
/** Fonction de redimensionnement de la grille (responsive) */
export class IsiDtoGridResponsiveFeature extends IsiDtoGridFeature implements IIsiDtoGridResponsiveFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridResponsiveFeature, Isilog.IsiFramework.IsiDataTransferObject";
    nbMaxColumn?: number;
    isSingleColumnEnabled?: boolean;
    responsiveModes?: { [key: string]: IsiDtoGridResponsiveMode; };

    constructor(data?: IIsiDtoGridResponsiveFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nbMaxColumn = _data["nbMaxColumn"] !== undefined ? _data["nbMaxColumn"] : 0;
            this.isSingleColumnEnabled = _data["isSingleColumnEnabled"] !== undefined ? _data["isSingleColumnEnabled"] : false;
            this.responsiveModes = _data["responsiveModes"] !== undefined ? _data["responsiveModes"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridResponsiveFeature): IsiDtoGridResponsiveFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridResponsiveFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["nbMaxColumn"] = this.nbMaxColumn !== undefined ? this.nbMaxColumn : 0;
        data["isSingleColumnEnabled"] = this.isSingleColumnEnabled !== undefined ? this.isSingleColumnEnabled : false;
        data["responsiveModes"] = this.responsiveModes !== undefined ? this.responsiveModes : <any>null;
        return data;
    }
}
/** Fonction de mise à jour des cellules */
export interface IIsiDtoGridUpdatingFeature extends IIsiDtoGridFeature  {
    /** Obtient ou définit la valeur qui indique si l'on peut supprimer une ligne dans la grille. */
    enableDeleteRow?: boolean;
    /** Obtient ou définit la valeur qui indique si l'on peut ajouter une nouvelle ligne dans la grille. */
    enableAddRow?: boolean;
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridUpdatingFeature extends IsiDtoGridFeature implements IIsiDtoGridUpdatingFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridUpdatingFeature, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définit la valeur qui indique si l'on peut supprimer une ligne dans la grille. */
    enableDeleteRow?: boolean;
    /** Obtient ou définit la valeur qui indique si l'on peut ajouter une nouvelle ligne dans la grille. */
    enableAddRow?: boolean;

    constructor(data?: IIsiDtoGridUpdatingFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.enableDeleteRow = _data["enableDeleteRow"] !== undefined ? _data["enableDeleteRow"] : false;
            this.enableAddRow = _data["enableAddRow"] !== undefined ? _data["enableAddRow"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGridUpdatingFeature): IsiDtoGridUpdatingFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridUpdatingFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["enableDeleteRow"] = this.enableDeleteRow !== undefined ? this.enableDeleteRow : false;
        data["enableAddRow"] = this.enableAddRow !== undefined ? this.enableAddRow : false;
        return data;
    }
}
/** Fonction de tri */
export interface IIsiDtoGridSortingFeature extends IIsiDtoGridFeature  {
    mode?: string;
}
/** Fonction de tri */
export class IsiDtoGridSortingFeature extends IsiDtoGridFeature implements IIsiDtoGridSortingFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridSortingFeature, Isilog.IsiFramework.IsiDataTransferObject";
    mode?: string;

    constructor(data?: IIsiDtoGridSortingFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mode = _data["mode"] !== undefined ? _data["mode"] : "single";
        }
    }

    static fromJS(data?: IIsiDtoGridSortingFeature): IsiDtoGridSortingFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSortingFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["mode"] = this.mode !== undefined ? this.mode : "single";
        return data;
    }
}
/** Fonction de pagination */
export interface IIsiDtoGridPagingFeature extends IIsiDtoGridFeature  {
    /** Obtient ou définit le nombre de ligne par page. */
    pageSize?: number;
}
/** Fonction de pagination */
export class IsiDtoGridPagingFeature extends IsiDtoGridFeature implements IIsiDtoGridPagingFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridPagingFeature, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définit le nombre de ligne par page. */
    pageSize?: number;

    constructor(data?: IIsiDtoGridPagingFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : 25;
        }
    }

    static fromJS(data?: IIsiDtoGridPagingFeature): IsiDtoGridPagingFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridPagingFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : 25;
        return data;
    }
}
/** Fonction de groupement */
export interface IIsiDtoGridGroupingFeature extends IIsiDtoGridFeature  {
    /** Libellé indiquant par quelles colonnes la grille est groupée */
    withGroupingLabel?: string;
    /** Libellé indiquant l'endroit ou glisser les colonnes */
    noGroupingLabel?: string;
    /** Obtient ou définit si les groupements doivent être dépliés par défaut ou non */
    initialExpand?: boolean;
    /** Obtient la liste des groupements. */
    groupments?: IIsiDtoGridGroupment[];
}
export interface IIsiDtoGridGroupment extends IIsiDataTransferObject  {
    dir?: string;
    allowGrouping?: boolean;
    isGroupBy?: boolean;
    columnKey?: string;
}
export class IsiDtoGridGroupment extends IsiDataTransferObject implements IIsiDtoGridGroupment {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridGroupment, Isilog.IsiFramework.IsiDataTransferObject";
    dir?: string;
    allowGrouping?: boolean;
    isGroupBy?: boolean;
    columnKey?: string;

    constructor(data?: IIsiDtoGridGroupment) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dir = _data["dir"] !== undefined ? _data["dir"] : <any>null;
            this.allowGrouping = _data["allowGrouping"] !== undefined ? _data["allowGrouping"] : true;
            this.isGroupBy = _data["isGroupBy"] !== undefined ? _data["isGroupBy"] : false;
            this.columnKey = _data["columnKey"] !== undefined ? _data["columnKey"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridGroupment): IsiDtoGridGroupment {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridGroupment();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["dir"] = this.dir !== undefined ? this.dir : <any>null;
        data["allowGrouping"] = this.allowGrouping !== undefined ? this.allowGrouping : true;
        data["isGroupBy"] = this.isGroupBy !== undefined ? this.isGroupBy : false;
        data["columnKey"] = this.columnKey !== undefined ? this.columnKey : <any>null;
        return data;
    }
}
export class IsiDtoGridGroupingFeature extends IsiDtoGridFeature implements IIsiDtoGridGroupingFeature {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridGroupingFeature, Isilog.IsiFramework.IsiDataTransferObject";
    /** Libellé indiquant par quelles colonnes la grille est groupée */
    withGroupingLabel?: string;
    /** Libellé indiquant l'endroit ou glisser les colonnes */
    noGroupingLabel?: string;
    /** Obtient ou définit si les groupements doivent être dépliés par défaut ou non */
    initialExpand?: boolean;
    /** Obtient la liste des groupements. */
    groupments?: IsiDtoGridGroupment[];

    constructor(data?: IIsiDtoGridGroupingFeature) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.withGroupingLabel = _data["withGroupingLabel"] !== undefined ? _data["withGroupingLabel"] : <any>null;
            this.noGroupingLabel = _data["noGroupingLabel"] !== undefined ? _data["noGroupingLabel"] : <any>null;
            this.initialExpand = _data["initialExpand"] !== undefined ? _data["initialExpand"] : true;
            this.groupments = _data["groupments"] !== undefined ? _data["groupments"] : [];
        }
    }

    static fromJS(data?: IIsiDtoGridGroupingFeature): IsiDtoGridGroupingFeature {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridGroupingFeature();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["withGroupingLabel"] = this.withGroupingLabel !== undefined ? this.withGroupingLabel : <any>null;
        data["noGroupingLabel"] = this.noGroupingLabel !== undefined ? this.noGroupingLabel : <any>null;
        data["initialExpand"] = this.initialExpand !== undefined ? this.initialExpand : true;
        data["groupments"] = this.groupments !== undefined ? this.groupments : [];
        return data;
    }
}
/** Objet regroupant l'ensemble des features de la grille */
export class IsiDtoGridFeatures extends IsiDataTransferObject implements IIsiDtoGridFeatures {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridFeatures, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définit la configuration de la fonction propriété (consultation de l'enregistrement). */
    property?: IsiDtoGridPropertyFeature;
    /** Obtient ou définit la configuration de la fonction d'ajout de selecteur de ligne dans les lignes */
    rowSelectors?: IsiDtoGridRowSelectorsFeature;
    /** Obtient ou définit la feature des tooltips. */
    tooltips?: IsiDtoGridTooltipsFeature;
    /** Obtient ou définit la configuration de la fonction de déplacement (réordonnancement) des colonnes */
    columnMoving?: IsiDtoGridColumnMovingFeature;
    /** Obtient ou définit la configuration de la fonction de redimensionnement des colonnes. */
    resizing?: IsiDtoGridResizingFeature;
    /** Obtient ou définit la configuration de chargement des lignes à la demande. */
    appendRowsOnDemand?: IsiDtoGridAppendRowsOnDemandFeature;
    /** Obtient ou définit la configuration de la fonction de selection des lignes. */
    selection?: IsiDtoGridSelectionFeature;
    /** Obtient ou définit la configuration de la fonction de filtrage. */
    filtering?: IsiDtoGridFilteringFeature;
    /** Obtient ou définit la configuration de la fonction de redimensionnement de la grille (responsive). */
    hiding?: IsiDtoGridHidingFeature;
    responsive?: IsiDtoGridResponsiveFeature;
    /** Obtient ou définit la configuration de la fonction de mise à jour (édition) des cellules. */
    updating?: IsiDtoGridUpdatingFeature;
    /** Obtient ou définit la configuration de la fonction de tri. */
    sorting?: IsiDtoGridSortingFeature;
    /** Obtient ou définit la configuration de la fonction de pagination. */
    paging?: IsiDtoGridPagingFeature;
    /** Obtient ou définit la configuration de la fonction de groupement. */
    grouping?: IsiDtoGridGroupingFeature;

    constructor(data?: IIsiDtoGridFeatures) {
        super(data);
        if (data) {
            this.property = data.property && !(<any>data.property).toJSON ? new IsiDtoGridPropertyFeature(data.property) : <IsiDtoGridPropertyFeature>this.property;
            this.rowSelectors = data.rowSelectors && !(<any>data.rowSelectors).toJSON ? new IsiDtoGridRowSelectorsFeature(data.rowSelectors) : <IsiDtoGridRowSelectorsFeature>this.rowSelectors;
            this.tooltips = data.tooltips && !(<any>data.tooltips).toJSON ? new IsiDtoGridTooltipsFeature(data.tooltips) : <IsiDtoGridTooltipsFeature>this.tooltips;
            this.columnMoving = data.columnMoving && !(<any>data.columnMoving).toJSON ? new IsiDtoGridColumnMovingFeature(data.columnMoving) : <IsiDtoGridColumnMovingFeature>this.columnMoving;
            this.resizing = data.resizing && !(<any>data.resizing).toJSON ? new IsiDtoGridResizingFeature(data.resizing) : <IsiDtoGridResizingFeature>this.resizing;
            this.appendRowsOnDemand = data.appendRowsOnDemand && !(<any>data.appendRowsOnDemand).toJSON ? new IsiDtoGridAppendRowsOnDemandFeature(data.appendRowsOnDemand) : <IsiDtoGridAppendRowsOnDemandFeature>this.appendRowsOnDemand;
            this.selection = data.selection && !(<any>data.selection).toJSON ? new IsiDtoGridSelectionFeature(data.selection) : <IsiDtoGridSelectionFeature>this.selection;
            this.filtering = data.filtering && !(<any>data.filtering).toJSON ? new IsiDtoGridFilteringFeature(data.filtering) : <IsiDtoGridFilteringFeature>this.filtering;
            this.hiding = data.hiding && !(<any>data.hiding).toJSON ? new IsiDtoGridHidingFeature(data.hiding) : <IsiDtoGridHidingFeature>this.hiding;
            this.responsive = data.responsive && !(<any>data.responsive).toJSON ? new IsiDtoGridResponsiveFeature(data.responsive) : <IsiDtoGridResponsiveFeature>this.responsive;
            this.updating = data.updating && !(<any>data.updating).toJSON ? new IsiDtoGridUpdatingFeature(data.updating) : <IsiDtoGridUpdatingFeature>this.updating;
            this.sorting = data.sorting && !(<any>data.sorting).toJSON ? new IsiDtoGridSortingFeature(data.sorting) : <IsiDtoGridSortingFeature>this.sorting;
            this.paging = data.paging && !(<any>data.paging).toJSON ? new IsiDtoGridPagingFeature(data.paging) : <IsiDtoGridPagingFeature>this.paging;
            this.grouping = data.grouping && !(<any>data.grouping).toJSON ? new IsiDtoGridGroupingFeature(data.grouping) : <IsiDtoGridGroupingFeature>this.grouping;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.property = _data["property"] ? IsiDtoGridPropertyFeature.fromJS(_data["property"]) : <any>null;
            this.rowSelectors = _data["rowSelectors"] ? IsiDtoGridRowSelectorsFeature.fromJS(_data["rowSelectors"]) : <any>null;
            this.tooltips = _data["tooltips"] ? IsiDtoGridTooltipsFeature.fromJS(_data["tooltips"]) : <any>null;
            this.columnMoving = _data["columnMoving"] ? IsiDtoGridColumnMovingFeature.fromJS(_data["columnMoving"]) : <any>null;
            this.resizing = _data["resizing"] ? IsiDtoGridResizingFeature.fromJS(_data["resizing"]) : <any>null;
            this.appendRowsOnDemand = _data["appendRowsOnDemand"] ? IsiDtoGridAppendRowsOnDemandFeature.fromJS(_data["appendRowsOnDemand"]) : <any>null;
            this.selection = _data["selection"] ? IsiDtoGridSelectionFeature.fromJS(_data["selection"]) : <any>null;
            this.filtering = _data["filtering"] ? IsiDtoGridFilteringFeature.fromJS(_data["filtering"]) : <any>null;
            this.hiding = _data["hiding"] ? IsiDtoGridHidingFeature.fromJS(_data["hiding"]) : <any>null;
            this.responsive = _data["responsive"] ? IsiDtoGridResponsiveFeature.fromJS(_data["responsive"]) : <any>null;
            this.updating = _data["updating"] ? IsiDtoGridUpdatingFeature.fromJS(_data["updating"]) : <any>null;
            this.sorting = _data["sorting"] ? IsiDtoGridSortingFeature.fromJS(_data["sorting"]) : <any>null;
            this.paging = _data["paging"] ? IsiDtoGridPagingFeature.fromJS(_data["paging"]) : <any>null;
            this.grouping = _data["grouping"] ? IsiDtoGridGroupingFeature.fromJS(_data["grouping"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridFeatures): IsiDtoGridFeatures {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridFeatures();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["property"] = this.property != null ? (<any>this.property).toJSON() : <any>null;
        data["rowSelectors"] = this.rowSelectors != null ? (<any>this.rowSelectors).toJSON() : <any>null;
        data["tooltips"] = this.tooltips != null ? (<any>this.tooltips).toJSON() : <any>null;
        data["columnMoving"] = this.columnMoving != null ? (<any>this.columnMoving).toJSON() : <any>null;
        data["resizing"] = this.resizing != null ? (<any>this.resizing).toJSON() : <any>null;
        data["appendRowsOnDemand"] = this.appendRowsOnDemand != null ? (<any>this.appendRowsOnDemand).toJSON() : <any>null;
        data["selection"] = this.selection != null ? (<any>this.selection).toJSON() : <any>null;
        data["filtering"] = this.filtering != null ? (<any>this.filtering).toJSON() : <any>null;
        data["hiding"] = this.hiding != null ? (<any>this.hiding).toJSON() : <any>null;
        data["responsive"] = this.responsive != null ? (<any>this.responsive).toJSON() : <any>null;
        data["updating"] = this.updating != null ? (<any>this.updating).toJSON() : <any>null;
        data["sorting"] = this.sorting != null ? (<any>this.sorting).toJSON() : <any>null;
        data["paging"] = this.paging != null ? (<any>this.paging).toJSON() : <any>null;
        data["grouping"] = this.grouping != null ? (<any>this.grouping).toJSON() : <any>null;
        return data;
    }
}
export enum Mode {
    Classique = 0,
    Hierarchique = 1,
}
/** Définit le comportement des sous grilles d'une grille hierarchique. */
export interface IIsiDtoGridColumnLayout extends IIsiDataTransferObject  {
    /** Information pour l'utilisation CRUD */
    restSettings?: IIsiDtoGridRestDataSourceSettings;
    /** L'inseption car on peut avoir d'autre columnslayout niveau n+1 */
    columnsLayout?: IIsiDtoGridColumnLayout;
    /** Ensemble des features du layout */
    features?: IIsiDtoGridFeatures;
    /** L'attribut dans une valeur de réponse content l'information de la clef parente. */
    foreignKey?: string;
    /** L'attribut dans une valeur de réponse content l'information de Pk. */
    primaryKey?: string;
    /** Le nom de l'attribut contenant les valeurs dans le flux json de réponse. */
    reponseDataKey?: string;
    /** La clef en odata/EF il s'agit du nom de la property de la à charger (ie c'est aussi le GetXXXX qui sera sur le controlleur de la ressource). */
    key?: string;
    /** La descriptions des colonnes de la sous requêtes. */
    columns?: IIsiDtoGridColumn[];
}
export interface IIsiDtoGridRestDataSourceSettings extends IIsiDataTransferObject  {
    /** Obtient ou définit les paramètres liés à la suppression. */
    remove?: IIsiDtoGridRestDataSourceSettingsAction;
    /** Obtient ou définit les paramètres liés à la mis à jour. */
    update?: IIsiDtoGridRestDataSourceSettingsAction;
    /** Obtient ou définit les paramètres liés à l'ajout. */
    create?: IIsiDtoGridRestDataSourceSettingsAction;
}
/** Elle représente le paramétrage d'une action de la grille
lors de l'utilisation de service REST.
Elle contient en autre l'url du service à appeler. */
export interface IIsiDtoGridRestDataSourceSettingsAction extends IIsiDataTransferObject  {
    /** Indique si le traitement se fait par batch (lot) */
    batch?: boolean;
    /** Obtient ou définit le template de l'url  ${id} sera remplacé par la valeur de l'identifiant. */
    template?: string;
    /** Obtient ou définit l'url  */
    url?: string;
}
/** Elle représente le paramétrage d'une action de la grille
lors de l'utilisation de service REST.
Elle contient en autre l'url du service à appeler. */
export class IsiDtoGridRestDataSourceSettingsAction extends IsiDataTransferObject implements IIsiDtoGridRestDataSourceSettingsAction {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.Dto.WebGUI.Components.Grid.DataSources.IsiDtoGridRestDataSourceSettingsAction, Isilog.IsiFramework.IsiDataTransferObject";
    /** Indique si le traitement se fait par batch (lot) */
    batch?: boolean;
    /** Obtient ou définit le template de l'url  ${id} sera remplacé par la valeur de l'identifiant. */
    template?: string;
    /** Obtient ou définit l'url  */
    url?: string;

    constructor(data?: IIsiDtoGridRestDataSourceSettingsAction) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.batch = _data["batch"] !== undefined ? _data["batch"] : false;
            this.template = _data["template"] !== undefined ? _data["template"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridRestDataSourceSettingsAction): IsiDtoGridRestDataSourceSettingsAction {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridRestDataSourceSettingsAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["batch"] = this.batch !== undefined ? this.batch : false;
        data["template"] = this.template !== undefined ? this.template : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}
export class IsiDtoGridRestDataSourceSettings extends IsiDataTransferObject implements IIsiDtoGridRestDataSourceSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.Dto.WebGUI.Components.Grid.DataSources.IsiDtoGridRestDataSourceSettings, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définit les paramètres liés à la suppression. */
    remove?: IsiDtoGridRestDataSourceSettingsAction;
    /** Obtient ou définit les paramètres liés à la mis à jour. */
    update?: IsiDtoGridRestDataSourceSettingsAction;
    /** Obtient ou définit les paramètres liés à l'ajout. */
    create?: IsiDtoGridRestDataSourceSettingsAction;

    constructor(data?: IIsiDtoGridRestDataSourceSettings) {
        super(data);
        if (data) {
            this.remove = data.remove && !(<any>data.remove).toJSON ? new IsiDtoGridRestDataSourceSettingsAction(data.remove) : <IsiDtoGridRestDataSourceSettingsAction>this.remove;
            this.update = data.update && !(<any>data.update).toJSON ? new IsiDtoGridRestDataSourceSettingsAction(data.update) : <IsiDtoGridRestDataSourceSettingsAction>this.update;
            this.create = data.create && !(<any>data.create).toJSON ? new IsiDtoGridRestDataSourceSettingsAction(data.create) : <IsiDtoGridRestDataSourceSettingsAction>this.create;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.remove = _data["remove"] ? IsiDtoGridRestDataSourceSettingsAction.fromJS(_data["remove"]) : <any>null;
            this.update = _data["update"] ? IsiDtoGridRestDataSourceSettingsAction.fromJS(_data["update"]) : <any>null;
            this.create = _data["create"] ? IsiDtoGridRestDataSourceSettingsAction.fromJS(_data["create"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridRestDataSourceSettings): IsiDtoGridRestDataSourceSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridRestDataSourceSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["remove"] = this.remove != null ? (<any>this.remove).toJSON() : <any>null;
        data["update"] = this.update != null ? (<any>this.update).toJSON() : <any>null;
        data["create"] = this.create != null ? (<any>this.create).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoGridColumn extends IIsiDataTransferObject  {
    /** Tooltip de l'entête de colonne */
    headerTooltip?: string;
    /** Type d'aggrégation de la colonne */
    typeAggreg?: TypeAggregation;
    /** Retourne l'index de la colonne */
    columnIndex?: number;
    /** Indique si la colonne accepte les tooltips */
    allowTooltips?: boolean;
    /** Type du contrôle sur le formulaire associé */
    columnRacc?: string;
    /** Type du contrôle sur le formulaire associé */
    associateFormCtrlType?: TypeCtrl;
    /** Permet l'alignement à droite des textes dans les colonnes des DA */
    alignRight?: boolean;
    /** Formattage du contrôle associé */
    ctrlFormat?: CtrlFormat;
    fieldLength?: number;
    /** Id de la datasource liée à la colonne. */
    dataSourceId?: string;
    /** Indique si la colonne échappe le HTML ou nons */
    escapeHtml?: EscapeType;
    /** définit si c'est un colonne lié ou non */
    unbound?: boolean;
    /** Définit la formule à utiliser */
    formula?: any;
    id?: number;
    renderType?: ColumnRenderTypes;
    formatter?: any;
    columnCssClass?: string;
    headerCssClass?: string;
    format?: string;
    textColumnKey?: string;
    updating?: IIsiDtoGridUpdatingFeatureColumnSettings;
    sorting?: IIsiDtoGridSortingFeatureColumnSettings;
    template?: string;
    width?: string;
    key?: string;
    hidden?: boolean;
    headerText?: string;
    dataType?: string;
}
export enum TypeAggregation {
    Text = 0,
    Somme = 1,
    Moyenne = 2,
    Minimum = 3,
    Maximum = 4,
    Count = 5,
    None = 6,
}
export enum TypeCtrl {
    None = 0,
    MultilineText = 1,
    Connexe = 2,
    Others = -1,
}
export enum CtrlFormat {
    None = 0,
    Text = 1,
    Numerical = 2,
    Price = 3,
    Amount = 4,
    Boolean = 5,
    Date = 6,
    Hour = 7,
    DateHour = 8,
    RichText = 9,
}
export enum EscapeType {
    None = 0,
    Encode = 1,
    Sanitarize = 2,
}
/** Les types de rendu possibles pour une colonne. */
export enum ColumnRenderTypes {
    Custom = 0,
    Boolean = 1,
    Checkbox = 2,
}
/** Fonction de mise à jour des cellules */
export interface IIsiDtoGridUpdatingFeatureColumnSettings extends IIsiDtoGridColumnSettings  {
    readOnly?: boolean;
    req?: boolean;
    eT?: string;
    edVK?: string;
    edTK?: string;
    edUrl?: string;
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridUpdatingFeatureColumnSettings extends IsiDtoGridColumnSettings implements IIsiDtoGridUpdatingFeatureColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridUpdatingFeatureColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";
    readOnly?: boolean;
    req?: boolean;
    eT?: string;
    edVK?: string;
    edTK?: string;
    edUrl?: string;

    constructor(data?: IIsiDtoGridUpdatingFeatureColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.readOnly = _data["readOnly"] !== undefined ? _data["readOnly"] : false;
            this.req = _data["req"] !== undefined ? _data["req"] : false;
            this.eT = _data["eT"] !== undefined ? _data["eT"] : "text";
            this.edVK = _data["edVK"] !== undefined ? _data["edVK"] : <any>null;
            this.edTK = _data["edTK"] !== undefined ? _data["edTK"] : <any>null;
            this.edUrl = _data["edUrl"] !== undefined ? _data["edUrl"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridUpdatingFeatureColumnSettings): IsiDtoGridUpdatingFeatureColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridUpdatingFeatureColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["readOnly"] = this.readOnly !== undefined ? this.readOnly : false;
        data["req"] = this.req !== undefined ? this.req : false;
        data["eT"] = this.eT !== undefined ? this.eT : "text";
        data["edVK"] = this.edVK !== undefined ? this.edVK : <any>null;
        data["edTK"] = this.edTK !== undefined ? this.edTK : <any>null;
        data["edUrl"] = this.edUrl !== undefined ? this.edUrl : <any>null;
        return data;
    }
}
/** Fonction de mise à jour des cellules */
export interface IIsiDtoGridSortingFeatureColumnSettings extends IIsiDtoGridColumnSettings  {
    direction?: string;
    allowSorting?: boolean;
}
/** Fonction de mise à jour des cellules */
export class IsiDtoGridSortingFeatureColumnSettings extends IsiDtoGridColumnSettings implements IIsiDtoGridSortingFeatureColumnSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Features.IsiDtoGridSortingFeatureColumnSettings, Isilog.IsiFramework.IsiDataTransferObject";
    direction?: string;
    allowSorting?: boolean;

    constructor(data?: IIsiDtoGridSortingFeatureColumnSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.direction = _data["direction"] !== undefined ? _data["direction"] : "False";
            this.allowSorting = _data["allowSorting"] !== undefined ? _data["allowSorting"] : true;
        }
    }

    static fromJS(data?: IIsiDtoGridSortingFeatureColumnSettings): IsiDtoGridSortingFeatureColumnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSortingFeatureColumnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["direction"] = this.direction !== undefined ? this.direction : "False";
        data["allowSorting"] = this.allowSorting !== undefined ? this.allowSorting : true;
        return data;
    }
}
export class IsiDtoGridColumn extends IsiDataTransferObject implements IIsiDtoGridColumn {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridColumn, Isilog.IsiFramework.IsiDataTransferObject";
    /** Tooltip de l'entête de colonne */
    headerTooltip?: string;
    /** Type d'aggrégation de la colonne */
    typeAggreg?: TypeAggregation;
    /** Retourne l'index de la colonne */
    columnIndex?: number;
    /** Indique si la colonne accepte les tooltips */
    allowTooltips?: boolean;
    /** Type du contrôle sur le formulaire associé */
    columnRacc?: string;
    /** Type du contrôle sur le formulaire associé */
    associateFormCtrlType?: TypeCtrl;
    /** Permet l'alignement à droite des textes dans les colonnes des DA */
    alignRight?: boolean;
    /** Formattage du contrôle associé */
    ctrlFormat?: CtrlFormat;
    fieldLength?: number;
    /** Id de la datasource liée à la colonne. */
    dataSourceId?: string;
    /** Indique si la colonne échappe le HTML ou nons */
    escapeHtml?: EscapeType;
    /** définit si c'est un colonne lié ou non */
    unbound?: boolean;
    /** Définit la formule à utiliser */
    formula?: any;
    id?: number;
    renderType?: ColumnRenderTypes;
    formatter?: any;
    columnCssClass?: string;
    headerCssClass?: string;
    format?: string;
    textColumnKey?: string;
    updating?: IsiDtoGridUpdatingFeatureColumnSettings;
    sorting?: IsiDtoGridSortingFeatureColumnSettings;
    template?: string;
    width?: string;
    key?: string;
    hidden?: boolean;
    headerText?: string;
    dataType?: string;

    constructor(data?: IIsiDtoGridColumn) {
        super(data);
        if (data) {
            this.updating = data.updating && !(<any>data.updating).toJSON ? new IsiDtoGridUpdatingFeatureColumnSettings(data.updating) : <IsiDtoGridUpdatingFeatureColumnSettings>this.updating;
            this.sorting = data.sorting && !(<any>data.sorting).toJSON ? new IsiDtoGridSortingFeatureColumnSettings(data.sorting) : <IsiDtoGridSortingFeatureColumnSettings>this.sorting;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.headerTooltip = _data["headerTooltip"] !== undefined ? _data["headerTooltip"] : <any>null;
            this.typeAggreg = _data["typeAggreg"] !== undefined ? _data["typeAggreg"] : TypeAggregation.Text;
            this.columnIndex = _data["columnIndex"] !== undefined ? _data["columnIndex"] : 0;
            this.allowTooltips = _data["allowTooltips"] !== undefined ? _data["allowTooltips"] : false;
            this.columnRacc = _data["columnRacc"] !== undefined ? _data["columnRacc"] : <any>null;
            this.associateFormCtrlType = _data["associateFormCtrlType"] !== undefined ? _data["associateFormCtrlType"] : TypeCtrl.None;
            this.alignRight = _data["alignRight"] !== undefined ? _data["alignRight"] : false;
            this.ctrlFormat = _data["ctrlFormat"] !== undefined ? _data["ctrlFormat"] : CtrlFormat.None;
            this.fieldLength = _data["fieldLength"] !== undefined ? _data["fieldLength"] : 0;
            this.dataSourceId = _data["dataSourceId"] !== undefined ? _data["dataSourceId"] : <any>null;
            this.escapeHtml = _data["escapeHtml"] !== undefined ? _data["escapeHtml"] : EscapeType.None;
            this.unbound = _data["unbound"] !== undefined ? _data["unbound"] : false;
            this.formula = _data["formula"] !== undefined ? _data["formula"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : 0;
            this.renderType = _data["renderType"] !== undefined ? _data["renderType"] : ColumnRenderTypes.Custom;
            this.formatter = _data["formatter"] !== undefined ? _data["formatter"] : <any>null;
            this.columnCssClass = _data["columnCssClass"] !== undefined ? _data["columnCssClass"] : <any>null;
            this.headerCssClass = _data["headerCssClass"] !== undefined ? _data["headerCssClass"] : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.textColumnKey = _data["textColumnKey"] !== undefined ? _data["textColumnKey"] : <any>null;
            this.updating = _data["updating"] ? IsiDtoGridUpdatingFeatureColumnSettings.fromJS(_data["updating"]) : <any>null;
            this.sorting = _data["sorting"] ? IsiDtoGridSortingFeatureColumnSettings.fromJS(_data["sorting"]) : <any>null;
            this.template = _data["template"] !== undefined ? _data["template"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.hidden = _data["hidden"] !== undefined ? _data["hidden"] : false;
            this.headerText = _data["headerText"] !== undefined ? _data["headerText"] : <any>null;
            this.dataType = _data["dataType"] !== undefined ? _data["dataType"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridColumn): IsiDtoGridColumn {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["headerTooltip"] = this.headerTooltip !== undefined ? this.headerTooltip : <any>null;
        data["typeAggreg"] = this.typeAggreg !== undefined ? this.typeAggreg : TypeAggregation.Text;
        data["columnIndex"] = this.columnIndex !== undefined ? this.columnIndex : 0;
        data["allowTooltips"] = this.allowTooltips !== undefined ? this.allowTooltips : false;
        data["columnRacc"] = this.columnRacc !== undefined ? this.columnRacc : <any>null;
        data["associateFormCtrlType"] = this.associateFormCtrlType !== undefined ? this.associateFormCtrlType : TypeCtrl.None;
        data["alignRight"] = this.alignRight !== undefined ? this.alignRight : false;
        data["ctrlFormat"] = this.ctrlFormat !== undefined ? this.ctrlFormat : CtrlFormat.None;
        data["fieldLength"] = this.fieldLength !== undefined ? this.fieldLength : 0;
        data["dataSourceId"] = this.dataSourceId !== undefined ? this.dataSourceId : <any>null;
        data["escapeHtml"] = this.escapeHtml !== undefined ? this.escapeHtml : EscapeType.None;
        data["unbound"] = this.unbound !== undefined ? this.unbound : false;
        data["formula"] = this.formula !== undefined ? this.formula : <any>null;
        data["id"] = this.id !== undefined ? this.id : 0;
        data["renderType"] = this.renderType !== undefined ? this.renderType : ColumnRenderTypes.Custom;
        data["formatter"] = this.formatter !== undefined ? this.formatter : <any>null;
        data["columnCssClass"] = this.columnCssClass !== undefined ? this.columnCssClass : <any>null;
        data["headerCssClass"] = this.headerCssClass !== undefined ? this.headerCssClass : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["textColumnKey"] = this.textColumnKey !== undefined ? this.textColumnKey : <any>null;
        data["updating"] = this.updating != null ? (<any>this.updating).toJSON() : <any>null;
        data["sorting"] = this.sorting != null ? (<any>this.sorting).toJSON() : <any>null;
        data["template"] = this.template !== undefined ? this.template : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["hidden"] = this.hidden !== undefined ? this.hidden : false;
        data["headerText"] = this.headerText !== undefined ? this.headerText : <any>null;
        data["dataType"] = this.dataType !== undefined ? this.dataType : <any>null;
        return data;
    }
}
/** Dto de gestion des colonnes des sous éléments hiérarchiques. */
export class IsiDtoGridColumnLayout extends IsiDataTransferObject implements IIsiDtoGridColumnLayout {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.Layouts.IsiDtoGridColumnLayout, Isilog.IsiFramework.IsiDataTransferObject";
    /** Information pour l'utilisation CRUD */
    restSettings?: IsiDtoGridRestDataSourceSettings;
    /** L'inseption car on peut avoir d'autre columnslayout niveau n+1 */
    columnsLayout?: IsiDtoGridColumnLayout;
    /** Ensemble des features du layout */
    features?: IsiDtoGridFeatures;
    /** L'attribut dans une valeur de réponse content l'information de la clef parente. */
    foreignKey?: string;
    /** L'attribut dans une valeur de réponse content l'information de Pk. */
    primaryKey?: string;
    /** Le nom de l'attribut contenant les valeurs dans le flux json de réponse. */
    reponseDataKey?: string;
    /** La clef en odata/EF il s'agit du nom de la property de la à charger (ie c'est aussi le GetXXXX qui sera sur le controlleur de la ressource). */
    key?: string;
    /** La descriptions des colonnes de la sous requêtes. */
    columns?: IsiDtoGridColumn[];

    constructor(data?: IIsiDtoGridColumnLayout) {
        super(data);
        if (data) {
            this.restSettings = data.restSettings && !(<any>data.restSettings).toJSON ? new IsiDtoGridRestDataSourceSettings(data.restSettings) : <IsiDtoGridRestDataSourceSettings>this.restSettings;
            this.columnsLayout = data.columnsLayout && !(<any>data.columnsLayout).toJSON ? new IsiDtoGridColumnLayout(data.columnsLayout) : <IsiDtoGridColumnLayout>this.columnsLayout;
            this.features = data.features && !(<any>data.features).toJSON ? new IsiDtoGridFeatures(data.features) : <IsiDtoGridFeatures>this.features;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.restSettings = _data["restSettings"] ? IsiDtoGridRestDataSourceSettings.fromJS(_data["restSettings"]) : <any>null;
            this.columnsLayout = _data["columnsLayout"] ? IsiDtoGridColumnLayout.fromJS(_data["columnsLayout"]) : <any>null;
            this.features = _data["features"] ? IsiDtoGridFeatures.fromJS(_data["features"]) : <any>null;
            this.foreignKey = _data["foreignKey"] !== undefined ? _data["foreignKey"] : <any>null;
            this.primaryKey = _data["primaryKey"] !== undefined ? _data["primaryKey"] : <any>null;
            this.reponseDataKey = _data["reponseDataKey"] !== undefined ? _data["reponseDataKey"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.columns = _data["columns"] !== undefined ? _data["columns"] : [];
        }
    }

    static fromJS(data?: IIsiDtoGridColumnLayout): IsiDtoGridColumnLayout {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumnLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["restSettings"] = this.restSettings != null ? (<any>this.restSettings).toJSON() : <any>null;
        data["columnsLayout"] = this.columnsLayout != null ? (<any>this.columnsLayout).toJSON() : <any>null;
        data["features"] = this.features != null ? (<any>this.features).toJSON() : <any>null;
        data["foreignKey"] = this.foreignKey !== undefined ? this.foreignKey : <any>null;
        data["primaryKey"] = this.primaryKey !== undefined ? this.primaryKey : <any>null;
        data["reponseDataKey"] = this.reponseDataKey !== undefined ? this.reponseDataKey : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["columns"] = this.columns !== undefined ? this.columns : [];
        return data;
    }
}
/** Représente une datasource assoicée à une colonne de la grille */
export interface IIsiDtoGridColumnDataSource extends IIsiDataTransferObject  {
    /** La datasource associée */
    dataSource?: IIsiDtoGridColumnDataSourceValue[];
}
/** Représente une datasource assoicée à une colonne de la grille */
export interface IIsiDtoGridColumnDataSourceValue extends IIsiDataTransferObject  {
    /** Le text de la valeur à afficher  */
    text?: string;
    /** La valeur de la colonne */
    value?: any;
}
/** Représente une datasource assoicée à une colonne de la grille */
export class IsiDtoGridColumnDataSourceValue extends IsiDataTransferObject implements IIsiDtoGridColumnDataSourceValue {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.DataSources.Column.IsiDtoGridColumnDataSourceValue, Isilog.IsiFramework.IsiDataTransferObject";
    /** Le text de la valeur à afficher  */
    text?: string;
    /** La valeur de la colonne */
    value?: any;

    constructor(data?: IIsiDtoGridColumnDataSourceValue) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridColumnDataSourceValue): IsiDtoGridColumnDataSourceValue {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumnDataSourceValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}
/** Représente une datasource assoicée à une colonne de la grille */
export class IsiDtoGridColumnDataSource extends IsiDataTransferObject implements IIsiDtoGridColumnDataSource {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.DataSources.Column.IsiDtoGridColumnDataSource, Isilog.IsiFramework.IsiDataTransferObject";
    /** La datasource associée */
    dataSource?: IsiDtoGridColumnDataSourceValue[];

    constructor(data?: IIsiDtoGridColumnDataSource) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dataSource = _data["dataSource"] !== undefined ? _data["dataSource"] : [];
        }
    }

    static fromJS(data?: IIsiDtoGridColumnDataSource): IsiDtoGridColumnDataSource {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridColumnDataSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["dataSource"] = this.dataSource !== undefined ? this.dataSource : [];
        return data;
    }
}
export class IsiDtoGrid extends IsiDtoComponentV4 implements IIsiDtoGrid {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGrid, Isilog.IsiFramework.IsiDataTransferObject";
    /** Dans le cadre d'une grille hierarchique, définit le nom de la colonne qui stocke le booléen qui indique si la ligne en cours a un enfant ou non */
    hasChildColumnName?: string;
    isSingleColumnTemplate?: boolean;
    /** Indique que la grille doit activer le mouseDown */
    withMouseDown?: boolean;
    /** Indique si la colonne de fin doit prendre toute la place restante
Par défaut true */
    expandLastColumn?: boolean;
    /** Mode de calcul de la hauteur d'une ligne d'une grille */
    rowHeightMode?: string;
    /** Hauteur (en px) d'une ligne d'une grille ou hauteur max (depend du RowHeightMode) */
    rowHeight?: number;
    /** Indique si l'on souhaite déplier par défaut les niveaux d'une grille hierarchique */
    expandAll?: number;
    /** Mode d'enregistrement de la grille */
    gridSaveMode?: SaveMode;
    /** Gets or sets the data source. */
    dataSource?: IIsiDtoGridDataSource;
    /** Obtient ou définit si la hauteur de la grille doit être automatique */
    autoHeight?: boolean;
    height?: string;
    /** Obtient ou définie la clé primaire réelle. La grille ne permet pas de travailler directement avec des clés composites. Techniquement la clé primaire
de la grille doit donc être une colonne unique. Cependant, il peut arriver que les enregistrements est une clé composées et nous auront besoin de cette information */
    realPk?: string[];
    /** Obtient ou définit la clé primaire. */
    pk?: string;
    /** Obtient ou définie l'url complète pour les modifications.
Par défaut : ~/?sessionID=IsiContext.SessionId    (en sachant que le tild sera remplacé par BaseUrl) */
    updatedUrl?: string;
    nbMaxColumns?: number;
    nbMaxRecords?: number;
    /** Obtient la liste des fonctionnalités actives sur la grille. */
    features?: IsiDtoGridFeatures;
    /** Mode d'affichage de la grille hiérarchique */
    mode?: Mode;
    /** L'inseption car on peut avoir d'autre columnslayout niveau n+1 */
    columnsLayout?: IsiDtoGridColumnLayout;
    columns?: IsiDtoGridColumn[];
    /** La datasource permettant de récupérer les informations de text associés à la colonnes / éditeur type isicombo
 => formatter
 => IsiComboEditorProvider */
    columnsDataSources?: { [key: string]: IsiDtoGridColumnDataSource; };

    constructor(data?: IIsiDtoGrid) {
        super(data);
        if (data) {
            this.dataSource = data.dataSource;
            this.features = data.features && !(<any>data.features).toJSON ? new IsiDtoGridFeatures(data.features) : <IsiDtoGridFeatures>this.features;
            this.columnsLayout = data.columnsLayout && !(<any>data.columnsLayout).toJSON ? new IsiDtoGridColumnLayout(data.columnsLayout) : <IsiDtoGridColumnLayout>this.columnsLayout;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasChildColumnName = _data["hasChildColumnName"] !== undefined ? _data["hasChildColumnName"] : <any>null;
            this.isSingleColumnTemplate = _data["isSingleColumnTemplate"] !== undefined ? _data["isSingleColumnTemplate"] : false;
            this.withMouseDown = _data["withMouseDown"] !== undefined ? _data["withMouseDown"] : false;
            this.expandLastColumn = _data["expandLastColumn"] !== undefined ? _data["expandLastColumn"] : false;
            this.rowHeightMode = _data["rowHeightMode"] !== undefined ? _data["rowHeightMode"] : <any>null;
            this.rowHeight = _data["rowHeight"] !== undefined ? _data["rowHeight"] : 0;
            this.expandAll = _data["expandAll"] !== undefined ? _data["expandAll"] : 0;
            this.gridSaveMode = _data["gridSaveMode"] !== undefined ? _data["gridSaveMode"] : SaveMode.None;
            this.dataSource = _data["dataSource"];
            this.autoHeight = _data["autoHeight"] !== undefined ? _data["autoHeight"] : false;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.realPk = _data["realPk"];
            this.pk = _data["pk"] !== undefined ? _data["pk"] : <any>null;
            this.updatedUrl = _data["updatedUrl"] !== undefined ? _data["updatedUrl"] : <any>null;
            this.nbMaxColumns = _data["nbMaxColumns"] !== undefined ? _data["nbMaxColumns"] : 0;
            this.nbMaxRecords = _data["nbMaxRecords"] !== undefined ? _data["nbMaxRecords"] : 0;
            this.features = _data["features"] ? IsiDtoGridFeatures.fromJS(_data["features"]) : <any>null;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : Mode.Classique;
            this.columnsLayout = _data["columnsLayout"] ? IsiDtoGridColumnLayout.fromJS(_data["columnsLayout"]) : <any>null;
            this.columns = _data["columns"] !== undefined ? _data["columns"] : [];
            this.columnsDataSources = _data["columnsDataSources"] !== undefined ? _data["columnsDataSources"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGrid): IsiDtoGrid {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGrid();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["hasChildColumnName"] = this.hasChildColumnName !== undefined ? this.hasChildColumnName : <any>null;
        data["isSingleColumnTemplate"] = this.isSingleColumnTemplate !== undefined ? this.isSingleColumnTemplate : false;
        data["withMouseDown"] = this.withMouseDown !== undefined ? this.withMouseDown : false;
        data["expandLastColumn"] = this.expandLastColumn !== undefined ? this.expandLastColumn : false;
        data["rowHeightMode"] = this.rowHeightMode !== undefined ? this.rowHeightMode : <any>null;
        data["rowHeight"] = this.rowHeight !== undefined ? this.rowHeight : 0;
        data["expandAll"] = this.expandAll !== undefined ? this.expandAll : 0;
        data["gridSaveMode"] = this.gridSaveMode !== undefined ? this.gridSaveMode : SaveMode.None;
        data["dataSource"] = this.dataSource != null ? (<any>this.dataSource).toJSON() : <any>null;
        data["autoHeight"] = this.autoHeight !== undefined ? this.autoHeight : false;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["realPk"] = this.realPk !== undefined ? this.realPk : [];
        data["pk"] = this.pk !== undefined ? this.pk : <any>null;
        data["updatedUrl"] = this.updatedUrl !== undefined ? this.updatedUrl : <any>null;
        data["nbMaxColumns"] = this.nbMaxColumns !== undefined ? this.nbMaxColumns : 0;
        data["nbMaxRecords"] = this.nbMaxRecords !== undefined ? this.nbMaxRecords : 0;
        data["features"] = this.features != null ? (<any>this.features).toJSON() : <any>null;
        data["mode"] = this.mode !== undefined ? this.mode : Mode.Classique;
        data["columnsLayout"] = this.columnsLayout != null ? (<any>this.columnsLayout).toJSON() : <any>null;
        data["columns"] = this.columns !== undefined ? this.columns : [];
        data["columnsDataSources"] = this.columnsDataSources !== undefined ? this.columnsDataSources : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridClientState extends IIsiDtoComponentClientState  {
    features?: IIsiDtoGridFeaturesClientState;
    columns?: IIsiDtoGridColumn[];
    data?: any[];
    totalLocalRecordsCount?: number;
    totalRecordCount?: number;
    scrollTop?: number;
    activeRow?: IIsiDtoGridSelectedRow;
    selectedRows?: IIsiDtoGridSelectedRow[];
    allLinesSelected?: boolean;
}
export interface IIsiDtoGridFeaturesClientState extends IIsiDataTransferObject  {
    sorting?: IIsiDtoGridSortingFeatureClientState;
    filtering?: IIsiDtoGridFilteringFeatureClientState;
}
export interface IIsiDtoGridSortingFeatureClientState extends IIsiDataTransferObject  {
    columnSettings?: any[];
}
export class IsiDtoGridSortingFeatureClientState extends IsiDataTransferObject implements IIsiDtoGridSortingFeatureClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridSortingFeatureClientState, Isilog.IsiFramework.IsiDataTransferObject";
    columnSettings?: any[];

    constructor(data?: IIsiDtoGridSortingFeatureClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.columnSettings = _data["columnSettings"];
        }
    }

    static fromJS(data?: IIsiDtoGridSortingFeatureClientState): IsiDtoGridSortingFeatureClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSortingFeatureClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["columnSettings"] = this.columnSettings !== undefined ? this.columnSettings : [];
        return data;
    }
}
export interface IIsiDtoGridFilteringFeatureClientState extends IIsiDataTransferObject  {
    globalFilterValue?: string;
    columnSettings?: any[];
    filtersByColumn?: any[];
    filters?: any[];
}
export class IsiDtoGridFilteringFeatureClientState extends IsiDataTransferObject implements IIsiDtoGridFilteringFeatureClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridFilteringFeatureClientState, Isilog.IsiFramework.IsiDataTransferObject";
    globalFilterValue?: string;
    columnSettings?: any[];
    filtersByColumn?: any[];
    filters?: any[];

    constructor(data?: IIsiDtoGridFilteringFeatureClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.globalFilterValue = _data["globalFilterValue"] !== undefined ? _data["globalFilterValue"] : <any>null;
            this.columnSettings = _data["columnSettings"];
            this.filtersByColumn = _data["filtersByColumn"];
            this.filters = _data["filters"];
        }
    }

    static fromJS(data?: IIsiDtoGridFilteringFeatureClientState): IsiDtoGridFilteringFeatureClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridFilteringFeatureClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["globalFilterValue"] = this.globalFilterValue !== undefined ? this.globalFilterValue : <any>null;
        data["columnSettings"] = this.columnSettings !== undefined ? this.columnSettings : [];
        data["filtersByColumn"] = this.filtersByColumn !== undefined ? this.filtersByColumn : [];
        data["filters"] = this.filters !== undefined ? this.filters : [];
        return data;
    }
}
export class IsiDtoGridFeaturesClientState extends IsiDataTransferObject implements IIsiDtoGridFeaturesClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridFeaturesClientState, Isilog.IsiFramework.IsiDataTransferObject";
    sorting?: IsiDtoGridSortingFeatureClientState;
    filtering?: IsiDtoGridFilteringFeatureClientState;

    constructor(data?: IIsiDtoGridFeaturesClientState) {
        super(data);
        if (data) {
            this.sorting = data.sorting && !(<any>data.sorting).toJSON ? new IsiDtoGridSortingFeatureClientState(data.sorting) : <IsiDtoGridSortingFeatureClientState>this.sorting;
            this.filtering = data.filtering && !(<any>data.filtering).toJSON ? new IsiDtoGridFilteringFeatureClientState(data.filtering) : <IsiDtoGridFilteringFeatureClientState>this.filtering;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sorting = _data["sorting"] ? IsiDtoGridSortingFeatureClientState.fromJS(_data["sorting"]) : <any>null;
            this.filtering = _data["filtering"] ? IsiDtoGridFilteringFeatureClientState.fromJS(_data["filtering"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridFeaturesClientState): IsiDtoGridFeaturesClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridFeaturesClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["sorting"] = this.sorting != null ? (<any>this.sorting).toJSON() : <any>null;
        data["filtering"] = this.filtering != null ? (<any>this.filtering).toJSON() : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export interface IIsiDtoGridSelectedRow extends IIsiDataTransferObject  {
    datas?: { [key: string]: string; };
    realKey?: { [key: string]: string; };
    key?: string;
}
/** Représente l'état de la grille coté client */
export class IsiDtoGridSelectedRow extends IsiDataTransferObject implements IIsiDtoGridSelectedRow {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridSelectedRow, Isilog.IsiFramework.IsiDataTransferObject";
    datas?: { [key: string]: string; };
    realKey?: { [key: string]: string; };
    key?: string;

    constructor(data?: IIsiDtoGridSelectedRow) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.datas = _data["datas"];
            this.realKey = _data["realKey"];
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridSelectedRow): IsiDtoGridSelectedRow {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridSelectedRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["datas"] = this.datas !== undefined ? this.datas : <any>null;
        data["realKey"] = this.realKey !== undefined ? this.realKey : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}
/** Représente l'état de la grille coté client */
export class IsiDtoGridClientState extends IsiDtoComponentClientState implements IIsiDtoGridClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.IsiDtoGridClientState, Isilog.IsiFramework.IsiDataTransferObject";
    features?: IsiDtoGridFeaturesClientState;
    columns?: IsiDtoGridColumn[];
    data?: any[];
    totalLocalRecordsCount?: number;
    totalRecordCount?: number;
    scrollTop?: number;
    activeRow?: IsiDtoGridSelectedRow;
    selectedRows?: IsiDtoGridSelectedRow[];
    allLinesSelected?: boolean;

    constructor(data?: IIsiDtoGridClientState) {
        super(data);
        if (data) {
            this.features = data.features && !(<any>data.features).toJSON ? new IsiDtoGridFeaturesClientState(data.features) : <IsiDtoGridFeaturesClientState>this.features;
            this.activeRow = data.activeRow && !(<any>data.activeRow).toJSON ? new IsiDtoGridSelectedRow(data.activeRow) : <IsiDtoGridSelectedRow>this.activeRow;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.features = _data["features"] ? IsiDtoGridFeaturesClientState.fromJS(_data["features"]) : <any>null;
            this.columns = _data["columns"] !== undefined ? _data["columns"] : [];
            this.data = _data["data"];
            this.totalLocalRecordsCount = _data["totalLocalRecordsCount"] !== undefined ? _data["totalLocalRecordsCount"] : 0;
            this.totalRecordCount = _data["totalRecordCount"] !== undefined ? _data["totalRecordCount"] : 0;
            this.scrollTop = _data["scrollTop"] !== undefined ? _data["scrollTop"] : 0;
            this.activeRow = _data["activeRow"] ? IsiDtoGridSelectedRow.fromJS(_data["activeRow"]) : <any>null;
            this.selectedRows = _data["selectedRows"] !== undefined ? _data["selectedRows"] : [];
            this.allLinesSelected = _data["allLinesSelected"] !== undefined ? _data["allLinesSelected"] : false;
        }
    }

    static fromJS(data?: IIsiDtoGridClientState): IsiDtoGridClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["features"] = this.features != null ? (<any>this.features).toJSON() : <any>null;
        data["columns"] = this.columns !== undefined ? this.columns : [];
        data["data"] = this.data !== undefined ? this.data : [];
        data["totalLocalRecordsCount"] = this.totalLocalRecordsCount !== undefined ? this.totalLocalRecordsCount : 0;
        data["totalRecordCount"] = this.totalRecordCount !== undefined ? this.totalRecordCount : 0;
        data["scrollTop"] = this.scrollTop !== undefined ? this.scrollTop : 0;
        data["activeRow"] = this.activeRow != null ? (<any>this.activeRow).toJSON() : <any>null;
        data["selectedRows"] = this.selectedRows !== undefined ? this.selectedRows : [];
        data["allLinesSelected"] = this.allLinesSelected !== undefined ? this.allLinesSelected : false;
        return data;
    }
}
export enum DataSourceTypeValue {
    Rest = 0,
    RemoteUrl = 1,
}
export abstract class IsiDtoGridDataSource extends IsiDataTransferObject implements IIsiDtoGridDataSource {
    /** Obtient ou définit si l'url de la source de donnée. */
    loadUrl?: string;
    /** Obtient ou définit si l'url de la source de donnée. */
    baseUrl?: string;
    /** Obtient ou définit le type de la source de donnée */
    dataSourceType?: DataSourceTypeValue;
    /** Obtient ou définit le nom de l'identifiant unique du champ. */
    primaryKey?: string;
    /** Obtient ou définit l''emplacement de la propriété qui contient le tableau d'enregistrements. */
    responseDataKey?: string;
    /** Obtient ou définit le type de contenu de la réponse. */
    responseContentType?: string;
    /** Obtient ou définit le type des données retournées par la source. */
    responseDataType?: string;

    constructor(data?: IIsiDtoGridDataSource) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.loadUrl = _data["loadUrl"] !== undefined ? _data["loadUrl"] : <any>null;
            this.baseUrl = _data["baseUrl"] !== undefined ? _data["baseUrl"] : <any>null;
            this.dataSourceType = _data["dataSourceType"] !== undefined ? _data["dataSourceType"] : DataSourceTypeValue.Rest;
            this.primaryKey = _data["primaryKey"] !== undefined ? _data["primaryKey"] : <any>null;
            this.responseDataKey = _data["responseDataKey"] !== undefined ? _data["responseDataKey"] : <any>null;
            this.responseContentType = _data["responseContentType"] !== undefined ? _data["responseContentType"] : <any>null;
            this.responseDataType = _data["responseDataType"] !== undefined ? _data["responseDataType"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridDataSource): IsiDtoGridDataSource {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IsiDtoGridDataSource' cannot be instantiated.");
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["loadUrl"] = this.loadUrl !== undefined ? this.loadUrl : <any>null;
        data["baseUrl"] = this.baseUrl !== undefined ? this.baseUrl : <any>null;
        data["dataSourceType"] = this.dataSourceType !== undefined ? this.dataSourceType : DataSourceTypeValue.Rest;
        data["primaryKey"] = this.primaryKey !== undefined ? this.primaryKey : <any>null;
        data["responseDataKey"] = this.responseDataKey !== undefined ? this.responseDataKey : <any>null;
        data["responseContentType"] = this.responseContentType !== undefined ? this.responseContentType : <any>null;
        data["responseDataType"] = this.responseDataType !== undefined ? this.responseDataType : <any>null;
        return data;
    }
}
export interface IIsiDtoGridRemoteUrlDataSource extends IIsiDtoGridDataSource  {
}
export class IsiDtoGridRemoteUrlDataSource extends IsiDtoGridDataSource implements IIsiDtoGridRemoteUrlDataSource {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.DataSources.IsiDtoGridRemoteUrlDataSource, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoGridRemoteUrlDataSource) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoGridRemoteUrlDataSource): IsiDtoGridRemoteUrlDataSource {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridRemoteUrlDataSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
export interface IIsiDtoGridRestDataSource extends IIsiDtoGridDataSource  {
    /** Obtient ou définit le type de la datasource. */
    dataSourceType?: DataSourceTypeValue;
    /** Obtient ou définit les paramètres de la source de données REST. */
    restSettings?: IIsiDtoGridRestDataSourceSettings;
}
export class IsiDtoGridRestDataSource extends IsiDtoGridDataSource implements IIsiDtoGridRestDataSource {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.Grid.DataSources.IsiDtoGridRestDataSource, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définit le type de la datasource. */
    dataSourceType?: DataSourceTypeValue;
    /** Obtient ou définit les paramètres de la source de données REST. */
    restSettings?: IsiDtoGridRestDataSourceSettings;

    constructor(data?: IIsiDtoGridRestDataSource) {
        super(data);
        if (data) {
            this.restSettings = data.restSettings && !(<any>data.restSettings).toJSON ? new IsiDtoGridRestDataSourceSettings(data.restSettings) : <IsiDtoGridRestDataSourceSettings>this.restSettings;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.dataSourceType = _data["dataSourceType"] !== undefined ? _data["dataSourceType"] : DataSourceTypeValue.Rest;
            this.restSettings = _data["restSettings"] ? IsiDtoGridRestDataSourceSettings.fromJS(_data["restSettings"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoGridRestDataSource): IsiDtoGridRestDataSource {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoGridRestDataSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["dataSourceType"] = this.dataSourceType !== undefined ? this.dataSourceType : DataSourceTypeValue.Rest;
        data["restSettings"] = this.restSettings != null ? (<any>this.restSettings).toJSON() : <any>null;
        return data;
    }
}
